/**
 * Created by Mark on 24/11/2016.
 */

import BaseStore from './base-store.js';
import Constants from '../constants/students.js';
import Student from '../classes/student.js';
import Language  from  '../classes/language.js';

class StudentsStore extends BaseStore {

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
        this.allStudents  = [];
        this.allMyStudents = [];
        this.studentJSON = {};
        this.class =[];
    }

    _processStudents(students){
        return students.map(function(__student){
            var student = new Student(__student.uid , __student.name , __student.username , __student.password , __student.classes , __student.lastLogin)
            this.studentJSON[__student.uid] = student;
            return student;
        }.bind(this));
    }

    _registerToActions(action) {


        switch(action.actionType)
        {
            case Constants.UPDATE_ALL_VIEWABLE_STUDENTS:
                this.allMyStudents = this._processStudents(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_ALL_DELETED_STUDENTS:
                this.allDeleted = this._processStudents(action.response);
                this.emit("UPDATE_ALL_DELETED_STUDENTS");
                break;
            case Constants.UPDATE_ALL_STUDENTS:
                this.allStudents = this._processStudents(action.response);
                this.emitChange();
                break;
            case Constants.UPDATE_STUDENTS_IN_CLASSES:
                this.class = this._processStudents(action.response);
                this.emit("UPDATE_CLASS_STUDENTS");
                break;
            case Constants.UPDATE_STUDENT:
                this.student = new Student(action.response.uid , action.response.name , action.response.username , action.response.password , action.response.classes ,  action.response.lastLogin)
                this.emit("STUDENT_UPDATE");
                break;
            case Constants.UPDATE_STUDENT_LANGUAGES:

                this.studentlanguages = action.response.map(function(language){
                    return new Language(language.name , language.ietf ,  language.isInterface);
                });

                this.emit("STUDENT_LANGUAGE_UPDATE");
                break;

            case Constants.UPDATE_STUDENT_RECENT:
                this.studentActivity = action.response;
                this.emit("UPDATE_STUDENT_ACTIVITY");
                break;
        }

    }

    getStudentByID(id){
        return this.studentJSON[id];
    }

}

export default new StudentsStore();


// WEBPACK FOOTER //
// ./src/store/student-store.js